import { Host, hosts } from "../../../yoello-lib/modules/host/Hosts";
import { SET_VENUE_DATA } from "../newVenue/state/newVenue.action";
import { ISelfsignupState, ISelfsignupAction, ESignupStages, IUserData, ILead, IAcquirer } from "../types";
import { BackStages } from "./BackStages";
import { GO_BACK, SET_ACQUIRER_DATA, SET_HUBSPOT_ID, SET_RESELLER, SET_LEAD_DATA, SET_LEAD_ID, SET_SALES_REF, SET_SNAPSHOT, SET_STAGE, SET_SUBSCRIPTION, SET_TITLE, SET_USER_DETAILS } from "./signup.action";

const generateVenueLocationConfig = (host: string) => {
    switch (host) {
        case hosts.zerobubble:
            return { name: "Malta", value: "MT" }
        case hosts.bna:
            return { name: "Canada", value: "Ca" }
        default:
            return { name: "United Kingdom", value: "GB" }
    }
}

export function SignupReducer(state: ISelfsignupState, action: ISelfsignupAction) {
    switch (action.type) {
        case SET_TITLE:
            return {
                ...state,
                title: action.payload as string
            }
        case SET_USER_DETAILS:
            return {
                ...state,
                userData: action.payload as IUserData,
                stage: ESignupStages.VENUE
            }
        case SET_VENUE_DATA:
            const data = action.payload as any
            const venueData = data.venueDetails as any
            let venueStage = ESignupStages.SUBSCRIPTION;
            if (venueData.venue_location.value.includes('invalid')) {
                venueStage = ESignupStages.INVALIDLOCATION;
            }
            return {
                ...state,
                venueData,
                stage: venueStage
            }
        case SET_SUBSCRIPTION:
            return {
                ...state,
                selectedSubscription: action.payload as string
            }
        case SET_STAGE:
            return {
                ...state,
                stage: action.payload as ESignupStages
            }
        case GO_BACK:
            const newStage = goBackStage(state.host, state.stage) as ESignupStages;
            return {
                ...state,
                stage: newStage
            }
        case SET_LEAD_DATA:
            const lead = { ...state.leadData, ...action.payload as ILead, 
                venue_location: generateVenueLocationConfig(state.host)
            };
            return {
                ...state,
                leadData: lead,
            }
        case SET_LEAD_ID:
            return {
                ...state,
                leadId: action.payload as string
            }
        case SET_SALES_REF:
            return {
                ...state,
                salesRef: action.payload as string
            }
        case SET_SNAPSHOT:
            return {
                ...state,
                ...action.payload as ISelfsignupState
            }
        case SET_ACQUIRER_DATA:
            return {
                ...state,
                acquirerData: action.payload as IAcquirer
            }
        case SET_HUBSPOT_ID:
            return {
                ...state,
                hubspotId: action.payload as string
            }
        case SET_RESELLER:
            return {
                ...state,
                reseller: action.payload as string
            }
        default:
            return state;
    }
}


function goBackStage(host: Host, stage: ESignupStages) {
    const hostsBack = BackStages[host];
    if (!hostsBack) {
        return ESignupStages.DETAILS;
    }
    return hostsBack[stage] ?? ESignupStages.DETAILS;
}